<!-- src/app/time-attendance/components/payroll-sync/pages/payroll-sync-history/payroll-sync-history.component.html -->
<app-payroll-nav></app-payroll-nav>

<div class="history-page">
  <div
    class="toast show"
    *ngIf="toastMessage"
    [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'"
    [class.warning]="toastKind === 'info'"
    (click)="clearToast()"
    role="status"
    aria-live="polite"
  >
    <img
      class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
      alt=""
      aria-hidden="true"
    />

    <div class="toast-title">
      {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
    </div>

    <div class="toast-body">{{ toastMessage }}</div>
  </div>

  <div class="page-header">
    <div class="title-block">
      <h2>Payroll Sync History</h2>
      <p class="subtitle">
        Review previously generated payable hours sync runs.
      </p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="inline-error" role="status" aria-live="polite">
    <p class="body">{{ errorMessage }}</p>
    <button type="button" class="icon-btn" (click)="errorMessage = null" aria-label="Close">×</button>
  </div>

  <div class="history-card">
    <div class="card-head">
      <div class="head-left">
        <h3>Run history</h3>
        <div class="sub">{{ totalCount }} total payroll sync runs</div>
      </div>

      <div class="head-right">
        <label class="page-size">
          Rows
          <select [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)" [disabled]="isLoading">
            <option [value]="6">6</option>
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
          </select>
        </label>
      </div>
    </div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Run</th>
            <th>Week</th>
            <th>Regular Hours</th>
            <th>Overtime Hours</th>
            <th>Synced By</th>
            <th>Synced At</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of historyRows; trackBy: trackById">
            <td>
              <span class="run-id">#{{ row.id }}</span>
            </td>

            <td>
              <div class="week-cell">
                <span class="week">{{ row.yearWeek }}</span>
                <span class="muted">YYWW ID: {{ row.yywwId }}</span>
              </div>
            </td>

            <td>
              <span class="hours regular">
                {{ row.totalRegularHours | number: '1.2-2' }}
              </span>
            </td>

            <td>
              <span class="hours overtime">
                {{ row.totalOvertimeHours | number: '1.2-2' }}
              </span>
            </td>

            <td>{{ getCreatedBy(row) }}</td>

            <td>
              <div class="date-cell">
                <span>{{ row.createdAt | date: 'shortDate' }}</span>
                <span class="muted">{{ row.createdAt | date: 'shortTime' }}</span>
              </div>
            </td>
          </tr>

          <tr *ngIf="!isLoading && !historyRows.length">
            <td colspan="6" class="empty">
              No payroll sync history found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <span>
        Page {{ pageNumber }} of {{ totalPages }}
      </span>

      <div class="pager-actions">
        <button type="button" class="ghost-btn" (click)="previousPage()" [disabled]="pageNumber <= 1 || isLoading">
          Previous
        </button>

        <button type="button" class="ghost-btn" (click)="nextPage()" [disabled]="pageNumber >= totalPages || isLoading">
          Next
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="busy-overlay">
    <div class="spinner"></div>
  </div>
</div>